module.exports = __webpack_public_path__ + "img/idp-ai.082846c2.png";